import administration from './administration'

// import chartsAndMaps from './charts-and-maps'

// import others from './others'
// import uiElements from './ui-elements'
import users from './users'

// Array of sections
export default [
  ...users,
  ...administration,

  // ...uiElements,
  // ...formsAndTables,
  // ...chartsAndMaps,
  // ...others,
]
